<script lang="ts" setup>
import { Link } from '@/models/link.model';
import { PropType, ref, watch } from 'vue';

const props = defineProps({
  label: {
    type: String,
    required: true,
  },
  modelValue: {
    type: Object as PropType<Link[]>,
    required: true,
  },
});

const sources = ref<Link[]>([...(props.modelValue || [])]);

const emit = defineEmits(['update:modelValue', 'change']);

function update() {
  emit('update:modelValue', sources.value);
  emit('change');
}

function addLink() {
  sources.value.push({
    description: '',
    href: '',
  });
  update();
}

function removeLink(index: number) {
  sources.value.splice(index, 1);
  update();
}

watch(
  () => props.modelValue,
  () => {
    Object.assign(sources.value, props.modelValue);
  },
  { deep: true },
);
</script>
<template>
  <div>
    <h3>{{ label }}s</h3>
    <v-list>
      <v-list-item v-for="(source, index) in sources" :key="index">
        <div class="source">
          <v-text-field
            v-model="source.description"
            label="Link"
            width="50%"
            :placeholder="`Link ${index + 1}`"
            required
            @change="update"
          ></v-text-field>
          &nbsp;
          <v-text-field
            v-model.number="source.href"
            width="50%"
            label="href"
            required
            @change="update"
          ></v-text-field>

          <v-btn
            icon="mdi-delete-outline"
            class="remove-button"
            density="compact"
            @click.prevent="removeLink(index)"
          ></v-btn>
        </div>
      </v-list-item>
    </v-list>
    <v-btn @click="addLink" color="success">Add {{ label }}</v-btn>
  </div>
</template>
<style scoped>
.source {
  display: flex;
  flex-direction: row;
  padding-right: 16px;
}
.remove-button {
  position: relative;
  top: 10px;
  left: 8px;
}
</style>
